import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { pageName } from './pageName';

const usePageviews = () => {
  const posthog = usePostHog();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!process.env.REACT_APP_POSTHOG_KEY) return;
    posthog.register({ page: pageName(pathname) });
    posthog.capture('$pageview');
  }, [posthog, pathname]);
};

export default usePageviews;
